var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-1"},[_c('div',{staticClass:"chart-wrap"},[_c('canvas',{ref:"chartElement",attrs:{"height":"200px","width":"400px"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }